/*
 * @Description:
 * @Author: lz
 * @Date: 2021-06-16 09:49:32
 * @LastEditTime: 2024-01-28 14:41:10
 * @LastEditors: Do not edit
 */
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "home",
    redirect: "/policySearch",
  },
  {
    //政策查询
    path: "/policySearch",
    name: "政策查询",
    // name: 'policySearch',
    component: () => import("@/views/policySearch"),
  },
  {
    //政策查询详情
    path: "/policyDetail",
    name: "政策查询详情",
    // name: "policyDetail",
    component: () => import("@/views/policySearch/policyDetail"),
  },
  {
    //产业政策（天津市）
    path: "/industryPolicy",
    name: "产业政策（天津市）",
    // name: "industryPolicy",
    component: () => import("@/views/industryPolicy"),
  },
  {
    //产业政策详情（天津市）
    path: "/industryDetail",
    name: "产业政策详情（天津市）",
    // name: "industryDetail",
    component: () => import("@/views/industryPolicy/industryDetail"),
  },
  {
    //政策查询详情页分享
    path: "/searchSharing",
    name: "政策查询详情页分享",
    // name: "searchSharing",
    props: true,
    component: () => import("@/views/share/searchSharing"),
    meta: {
      isMobile: true,
    },
  },
  {
    //政策发布
    path: "/policyPublish",
    name: "政策发布",
    // name: "policyPublish",
    component: () => import("@/views/policyPublish"),
  },
  {
    //添加政策信息
    path: "/addPolicy",
    name: "添加政策信息",
    // name: "addPolicy",
    component: () => import("@/views/policyPublish/addPolicy"),
  },
  {
    //政策文件
    path: "/policyDocuments",
    name: "政策文件",
    // name: "policyDocuments",
    component: () => import("@/views/policyDocuments"),
  },
  {
    //政策文件详情
    path: "/policyDocumentsDetail",
    name: "政策文件详情",
    // name: "policyDocumentsDetail",
    props: true,
    component: () => import("@/views/policyDocuments/policyDocumentsDetail"),
  },
  {
    //政策文件详情页分享
    path: "/fileSharing",
    name: "政策文件详情页分享",
    // name: "fileSharing",
    props: true,
    component: () => import("@/views/share/fileSharing"),
    meta: {
      isMobile: true,
    },
  },
  {
    //分享
    path: "/reportShare",
    name: "分享",
    // name: "reportShare",
    component: () => import("@/views/share/reportShare"),
    meta: {
      isMobile: true,
    },
  },
  {
    //政策匹配
    path: "/policyMatching",
    name: "政策匹配",
    // name: "policyMatching",
    component: () => import("@/views/policyMatching"),
  },
  {
    //政策生成报告
    path: "/policyGenerate",
    name: "政策生成报告",
    // name: "policyGenerate",
    component: () => import("@/views/policyMatching/policyGenerate"),
  },
  {
    //高新企业测评
    path: "/enterpriseHighNew",
    name: "高新企业测评",
    // name: "enterpriseHighNew",
    component: () => import("@/views/enterpriseHighNewN"),
  },
  {
    //高新企业测评结果
    path: "/enterpriseHighNew/result",
    name: "高新企业测评结果",
    // name: "enterpriseHighNewResult",
    component: () => import("@/views/enterpriseHighNewN/result"),
  },
  {
    //企业规模测评
    //企业规模测评or科技型企业测评
    path: "/enterpriseScale",
    name: "企业规模测评",
    // name: "enterpriseScale",
    component: () => import("@/views/enterpriseScale"),
  },
  {
    //企业测评结果
    path: "/enterpriseScale/result",
    name: "企业测评结果",
    // name: "result",
    component: () => import("@/views/enterpriseScale/result"),
  },
  {
    //企业规模测评
    //企业规模测评or科技型企业测评
    path: "/enterpriseScaleH5",
    name: "企业规模测评H5",
    // name: "enterpriseScaleH5",
    component: () => import("@/views/enterpriseScaleH5"),
    meta: { isMobile: true },
  },
  {
    //企业测评结果
    path: "/enterpriseScaleH5/result",
    name: "企业测评结果H5",
    // name: "enterpriseScaleH5Result",
    component: () => import("@/views/enterpriseScaleH5/result"),
    meta: { isMobile: true },
  },
  {
    //融资事件列表
    path: "/financingEvent",
    name: "融资事件列表",
    // name: "FinancingEvent",
    component: () => import("@/views/financingEvent"),
  },
  {
    //融资事件幸福投资
    path: "/financingEventDetail",
    name: "融资事件幸福投资",
    // name: "FinancingEventDetail",
    component: () => import("@/views/financingEvent/detail"),
  },
  {
    //优秀企业列表
    path: "/excellentCompany",
    name: "优秀企业列表",
    // name: "ExcellentCompany",
    component: () => import("@/views/excellentCompany"),
  },
  {
    //优秀企业推荐
    path: "/excellentCompanyRecommend",
    name: "优秀企业推荐",
    // name: "ExcellentCompanyRecommend",
    component: () => import("@/views/excellentCompany/recommend"),
  },
  {
    //专精特新测评入口
    path: "/enterpriseSpecial",
    name: "专精特新测评入口",
    // name: "enterpriseSpecial",
    component: () => import("@/views/enterpriseSpecial"),
  },
  {
    //专精特新测评入口
    path: "/enterpriseSpecial/record",
    name: "专精特新测评入口",
    // name: "record",
    component: () => import("@/views/enterpriseSpecial/record"),
  },
  {
    //中小企业测评
    path: "/enterpriseSpecial/smEvaluation",
    name: "中小企业测评",
    // name: "smEvaluation",
    component: () => import("@/views/enterpriseSpecial/smEvaluation"),
  },
  {
    //中小企业测评结果
    path: "/enterpriseSpecial/smEvaluation/result",
    name: "中小企业测评结果",
    // name: "smEvaluationResult",
    component: () => import("@/views/enterpriseSpecial/smEvaluation/result"),
  },
  {
    //小巨人测评
    path: "/enterpriseSpecial/littleGiant",
    name: "小巨人测评",
    // name: "littleGiant",
    component: () => import("@/views/enterpriseSpecial/littleGiant"),
  },
  {
    //小巨人测评结果
    path: "/enterpriseSpecial/littleGiant/result",
    name: "小巨人测评结果",
    // name: "littleGiantResult",
    component: () => import("@/views/enterpriseSpecial/littleGiant/result"),
  },
  // 新增页面
  {
    //商标搜索分析报告H5
    path: "/tmSearchH5",
    name: "商标搜索分析报告H5",
    // name: "tmSearchH5",
    component: () => import("@/views/tmSearchH5"),
    meta: {
      isMobile: true,
    },
  },
  {
    //公司商标风险测评H5
    path: "/ctmRiskH5",
    name: "公司商标风险测评H5",
    // name: "ctmRiskH5",
    component: () => import("@/views/ctmRiskH5"),
    meta: {
      isMobile: true,
    },
  },
  // 专精特新H5
  {
    //专精特新H5测评入口
    path: "/enterpriseSpecialH5",
    name: "专精特新H5测评入口",
    // name: "enterpriseSpecialH5",
    component: () => import("@/views/enterpriseSpecialH5"),
    meta: {
      isMobile: true,
    },
  },
  {
    //高新企业测评H5
    path: "/enterpriseHighNewH5",
    name: "高新企业测评H5",
    // name: "enterpriseHighNewH5",
    component: () => import("@/views/enterpriseHighNewH5"),
    meta: {
      isMobile: true,
    },
  },
  {
    //高新企业测评H5基础报告页
    path: "/enterpriseHighNewH5/basicReport",
    name: "高新企业测评H5基础报告页",
    // name: "enterpriseHighNewH5BasicReport",
    component: () => import("@/views/enterpriseHighNewH5/basicReport"),
    meta: {
      isMobile: true,
    },
  },
  {
    //高新企业测评H5完成报告页
    path: "/enterpriseHighNewH5/completeReport",
    name: "高新企业测评H5完成报告页",
    // name: "enterpriseHighNewH5CompleteReport",
    component: () => import("@/views/enterpriseHighNewH5/completeReport"),
    meta: {
      isMobile: true,
    },
  },
  {
    //高新企业测评H5测评页
    path: "/enterpriseHighNewH5/evaluation",
    name: "高新企业测评H5测评页",
    // name: "enterpriseHighNewH5Evaluation",
    component: () => import("@/views/enterpriseHighNewH5/evaluation"),
    meta: {
      isMobile: true,
    },
  },
  {
    //中小企业测评
    path: "/enterpriseSpecialH5/smEvaluation",
    name: "中小企业测评",
    // name: "smEvaluationH5",
    component: () => import("@/views/enterpriseSpecialH5/smEvaluation"),
    meta: {
      isMobile: true,
    },
  },
  {
    //中小企业测评结果
    path: "/enterpriseSpecialH5/smEvaluation/result",
    name: "中小企业测评结果",
    // name: "smEvaluationH5Result",
    component: () => import("@/views/enterpriseSpecialH5/smEvaluation/result"),
    meta: {
      isMobile: true,
    },
  },
  {
    //中小企业测评 陕西
    path: "/enterpriseSpecialH5/smEvaluationSX",
    name: "中小企业测评 陕西",
    // name: "smEvaluationH5SX",
    component: () => import("@/views/enterpriseSpecialH5/smEvaluationSX"),
    meta: {
      isMobile: true,
    },
  },
  {
    //中小企业测评结果 陕西
    path: "/enterpriseSpecialH5/smEvaluationSX/result",
    name: "中小企业测评结果 陕西",
    // name: "smEvaluationH5ResultSX",
    component: () =>
      import("@/views/enterpriseSpecialH5/smEvaluationSX/result"),
    meta: {
      isMobile: true,
    },
  },
  {
    //小巨人测评
    path: "/enterpriseSpecialH5/littleGiant",
    name: "小巨人测评H5",
    // name: "littleGiantH5",
    component: () => import("@/views/enterpriseSpecialH5/littleGiant"),
    meta: {
      isMobile: true,
    },
  },
  {
    //小巨人测评结果
    path: "/enterpriseSpecialH5/littleGiant/result",
    name: "小巨人测评结果H5",
    // name: "littleGiantH5Result",
    component: () => import("@/views/enterpriseSpecialH5/littleGiant/result"),
    meta: {
      isMobile: true,
    },
  },
  {
    //专精特新H5 登录
    path: "/enterpriseSpecialH5/login",
    name: "专精特新H5 登录",
    // name: "enterpriseSpecialH5Login",
    component: () => import("@/views/enterpriseSpecialH5/login/index"),
    meta: { isMobile: true },
  },
  {
    //专精特新H5 注册
    path: "/enterpriseSpecialH5/register",
    name: "专精特新H5 注册",
    // name: "enterpriseSpecialH5Register",
    component: () => import("@/views/enterpriseSpecialH5/register/index"),
    meta: { isMobile: true },
  },
  {
    //专精特新H5 忘记密码
    path: "/enterpriseSpecialH5/forget",
    name: "专精特新H5 忘记密码",
    // name: "enterpriseSpecialH5Forget",
    component: () => import("@/views/enterpriseSpecialH5/forget/index"),
    meta: { isMobile: true },
  },
  {
    //专精特新H5 协议
    path: "/enterpriseSpecialH5/agreement",
    name: "专精特新H5 协议",
    // name: "enterpriseSpecialH5Agreement",
    component: () => import("@/views/enterpriseSpecialH5/agreement/index"),
    meta: { isMobile: true },
  },
  {
    //专企业政策扶持报告H5
    path: "/policyH5",
    name: "专企业政策扶持报告H5",
    // name: "policyH5",
    component: () => import("@/views/policyH5/index.vue"),
    meta: { isMobile: true },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
